import React, {useMemo} from 'react';
import {DeepSearchParagraphsQuery} from 'features/Search/hooks';
import {RegulatoryDocument, RegulatoryDocumentParagraph} from 'types';
import {SearchResult} from './SearchResult';
import {SearchResultDeep} from '../SearchCards/SearchResultCardDeep';
import {EntityListColumn} from 'components';
import {ParagraphsContextProvider} from 'features/RegulatoryDocuments/components/DocumentDetails/ParagraphsContext';
import {ParagraphsList} from 'features/RegulatoryDocuments/components/DocumentDetails';
import {SelectionMode} from 'components/FluentUICompat';

const entityName = 'Paragraphs';
const arrayColumns: string[] = [];
const quickFilterColumns: string[] = arrayColumns;

type RegulationSearchResultProps = {
	currentViewKey: string;
	isResultCardFormat: boolean;
	loading: boolean;
	deepSearchData: DeepSearchParagraphsQuery | undefined;
};

export const DeepSearchResult: React.FC<
	RegulationSearchResultProps
> = props => {
	const propsResult = useMemo(() => {
		const columns: EntityListColumn[] = [];

		const searchedItems =
			props.deepSearchData?.searchParagraphs.regulatoryDocumentsSearchedPara ||
			[];
		const searchedItemsMeta =
			props.deepSearchData?.searchParagraphs.regulatoryDocumentsOtherData || [];

		const renderCard = (item: RegulatoryDocument, index?: number) => {
			const itemMeta = searchedItemsMeta.at(index ?? 0) as RegulatoryDocument;

			return (
				<SearchResultDeep
					key={item.id}
					itemMeta={itemMeta ?? item}
					itemSearchedParagraphs={item}
				/>
			);
		};

		const renderEntityList = (EntityList: React.ReactElement) => {
			const paragraphs = searchedItems
				.map((x, index) => {
					const parentData = searchedItemsMeta.at(index);
					return x.paragraphs.map(y => ({...y, level: 0, parent: parentData}));
				})
				.flat() as RegulatoryDocumentParagraph[];

			return (
				<ParagraphsContextProvider>
					<ParagraphsList
						paragraphs={paragraphs}
						includeRegulationAndVersionName
						selectionMode={SelectionMode.none}
						hideExcelButton={true}
						includeParaPositions
					/>
				</ParagraphsContextProvider>
			);
		};

		return {
			...props,
			entityName,
			searchedItems,
			columns,
			quickFilterColumns,
			renderCard,
			renderEntityList,
			initialShownItems: 1,
			deltaShownItems: 1,
		};
	}, [props]);

	return <SearchResult {...propsResult} />;
};
